module.exports = require("./../../_gen/starling/assets/JsonFactory");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/assets/JsonFactory.js
// module id = 155
// module chunks = 0